module.exports = __webpack_public_path__ + "kw.svg?8758e4ab9960cbd0372b2bdbb5a97db4";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/kw.svg
// module id = 1454
// module chunks = 0